import { combineSlices } from '@reduxjs/toolkit';

import appReducer from './app-slice';
import uiReducer from './ui-slice';
import authReducer from '@/features/auth/store/auth-slice';
import backofficeAuthReducer from '@/features/backoffice2020/store/backoffice-auth-slice';
import { bulkMessageSelectionReducer } from '@/features/bulk-message/store/bulk-message-selection-slice';
import { baseApi } from '@/shared/api/base-api';

export const rootReducer = combineSlices({
  auth: authReducer,
  backofficeAuth: backofficeAuthReducer,
  app: appReducer,
  ui: uiReducer,
  bulkMessageSelection: bulkMessageSelectionReducer,
  [baseApi.reducerPath]: baseApi.reducer,
});

export type RootState = ReturnType<typeof rootReducer>;
